export const Modules = {
  dashboard: 1,
  dashboardPage: 2,
  metrixInsights: 21,
  management: 100,
  meters: 101,
  meterReading: 102,
  cetDataConnectDisconnectRelay: 106,
  customProperty: 107,
  sites: 121,
  meterTags: 122,
  meterHierarchy: 123,
  meterGroups: 141,
  users: 161,
  roles: 181,
  contacts: 201,
  companySettings: 221,
  virtualMeters: 241,
  reportingSetup: 300,
  enem12: 301,
  nem12: 321,
  calculateSubstitution: 322,
  mdn: 341,
  qualityFlags: 361,
  meterEvents: 381,
  orion: 401,
  validationRules: 421,
  siteUsage: 441,
  reporting: 500,
  reportHistory: 501,
  enem12ReportOutput: 502,
  nem12ReportOutput: 503,
  mdnReportOutput: 504,
  qualityFlagReportOutput: 505,
  meterEventReportOutput: 506,
  orionReportOutput: 507,
  siteUsageOutput: 508,
  validationHistory: 521,
  validationSummary: 541,
  advancedEcoValidation: 561,
  iotDataSummary: 581,
  monitoring: 700,
  deviceStatus: 701,
  meterSchedules: 721,
  meterScheduleLogicApp: 722,
  meterScheduleLink: 723,
  meterScheduleAllColumns: 724,
  meterDataAudit: 741,
  dataTools: 800,
  dataCorrections: 801,
  correctMeterData: 802,
  markAsFinalAndResend: 803,
  nmiGenerator: 821,
  serialNumberGenerator: 841,
  propertyNumberGenerator: 861,
  nem12Viewer: 881,
  provisioning: 1000,
  importMeters: 1001,
  unprovisionedMeters: 1021,
  unprovisionedIoTDevices: 1041,
  alarmsSetup: 1100,
  alarmEvents: 1101,
  alarmProperty: 1121,
  integrations: 1200,
  iotSync: 1201,
  cetSync: 1221,
  advancedEcoSync: 1241,
  logs: 1300,
  systemLogs: 1301,
  advancedEcoProcessorLog: 1302,
  cetMeterSchedulerLog: 1303,
  cetMeterResyncLog: 1304,
  enem12FileProcessorLog: 1305,
  errorFilesLog: 1306,
  importSecureMeterLog: 1307,
  iotChirpStackLog: 1308,
  iotChirpStackFileImportLog: 1309,
  iotHubDataSyncLog: 1310,
  iotHubDataResyncLog: 1311,
  meterDataQueueLog: 1312,
  meterReadingQueueLog: 1313,
  meterScheduleImportLog: 1314,
  nem12FinalDataSubstitutionLog: 1315,
  nem12FileProcessorLog: 1316,
  openWebLog: 1317,
  preCalculateSubstitutionDataLog: 1318,
  serviceBusQueuesLog: 1319,
  userAuditLogs: 1341,
  logMaintenance: 1361,
  system: 1400,
  platformConfiguration: 1401,
  customerNameConfig: 1402,
  logoUploadConfig: 1403,
  timeOfUseConfig: 1404,
  iotMeterCalculationConfig: 1405,
  meterEventsConfig: 1406,
  enem12ReportConfig: 1407,
  nem12ReportConfig: 1408,
  meterTypeUOMConfig: 1409,
  deviceStatusConfig: 1410,
  emailConfig: 1411,
  meterChannelConfig: 1412,
  activityLogCleanupConfig: 1413,
  meterCustomPropertiesConfig: 1414,
  meterGroupUsersConfig: 1415,
  contactSupportConfig: 1416,
  publicHolidayConfig: 1417,
  tagConfig: 1418,
  dashboardMeterChannelConfig: 1419,
  reportEmailBodyConfig: 1420,
  meterStatusCodes: 1451,
  api: 1471,
  support: 1491,
};
